module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.4 12.8H19.2V1.6A1.6 1.6 0 0 0 17.6 0h-3.2a1.6 1.6 0 0 0-1.6 1.6v11.2H1.6A1.6 1.6 0 0 0 0 14.4v3.2a1.6 1.6 0 0 0 1.6 1.6h11.2v11.2a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.6-1.6V19.2h11.2a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.6-1.6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/plus-1.js
// module id = 1348
// module chunks = 14